import React from 'react';

interface Props {
  /** Button text before arming, e.g. "Revoke". */
  label: string;
  /** Button text once armed, e.g. "Really revoke? Yes". */
  confirmLabel: string;
  armed: boolean;
  disabled?: boolean;
  onArm: () => void;
  onCancel: () => void;
  onConfirm: () => void;
}

/**
 * Two-step destructive action: the first click only arms the button, so a
 * misclick cannot delete anything.
 */
const ConfirmAction: React.FC<Props> = ({
  label,
  confirmLabel,
  armed,
  disabled,
  onArm,
  onCancel,
  onConfirm,
}) =>
  armed ? (
    <div className="admin-confirm">
      <button
        type="button"
        className="admin-action admin-action--danger"
        disabled={disabled}
        onClick={onConfirm}
      >
        {confirmLabel}
      </button>
      <button
        type="button"
        className="admin-action"
        disabled={disabled}
        onClick={onCancel}
      >
        Cancel
      </button>
    </div>
  ) : (
    <button
      type="button"
      className="admin-action"
      disabled={disabled}
      onClick={onArm}
    >
      {label}
    </button>
  );

export default ConfirmAction;
